<template>
  <div class="adv-buy-container">
    <div class="adv-buy-card">
      <!-- 头部 -->
      <div class="adv-buy-header">
        <h3 class="adv-buy-title">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#e50914" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
          {{ $t('activity.detail') }}
        </h3>
        <button class="adv-close-btn" @click="onBack">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- 主体 -->
      <div class="adv-buy-body">
        <!-- 封面图 -->
        <div class="adv-cover">
          <img :src="current.img" :alt="current.title" class="adv-cover-img" />
          <div class="adv-cover-badge">
            <span class="badge-code"># {{ current.code }}</span>
          </div>
        </div>

        <!-- 信息区 -->
        <div class="adv-info">
          <h4 class="adv-title">{{ current.title }}</h4>

          <!-- 活动介绍 -->
          <div class="adv-section">
            <div class="adv-section-header">
              <span class="section-dot"></span>
              <h5>{{ $t('activity.desc') }}</h5>
            </div>
            <p class="adv-desc">{{ current.content || $t('activity.noDesc') }}</p>
          </div>

          <!-- 参与要求 -->
          <div class="adv-section">
            <div class="adv-section-header">
              <span class="section-dot"></span>
              <h5>{{ $t('activity.requirements') }}</h5>
            </div>
            <div class="adv-requirements">
              <div class="adv-requirement">
                <div class="req-icon dollar">$</div>
                <div class="req-info">
                  <span class="req-label">{{ $t('activity.minInvest') }}</span>
                  <span class="req-value">${{ current.price_min }}</span>
                </div>
              </div>
              <div class="adv-requirement">
                <div class="req-icon crown">👑</div>
                <div class="req-info">
                  <span class="req-label">{{ $t('activity.vipLevel') }}</span>
                  <span class="req-value">Lv {{ current.level || 0 }} </span>
                </div>
              </div>
              <div class="adv-requirement">
                <div class="req-icon users">👥</div>
                <div class="req-info">
                  <span class="req-label">{{ $t('activity.avgParticipation') }}</span>
                  <span class="req-value">{{ current.pre_num || 0 }} {{ $t('activity.avgParticipation') }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 表单区域 -->
          <div class="adv-form-grid">
            <!-- 选择国家 -->
            <div class="adv-form-group">
              <label>{{ $t('activity.country') }}</label>
              <a-select v-model:value="params.country" style="width: 100%" size="large">
                <a-select-option :value="item.id" v-for="item in countries" :key="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </div>

            <!-- 投流时间 -->
            <div class="adv-form-group">
              <label>{{ $t('activity.deliveryTime') }}</label>
              <div class="adv-static-display">{{ current?.days || 20 }} {{ $t('activity.deliveryTimeDesc') }}</div>
            </div>

            <!-- 选择性别 -->
            <div class="adv-form-group">
              <label>{{ $t('activity.gender') }}</label>
              <a-radio-group v-model:value="params.gender" class="adv-radio-group">
                <a-radio value="1" class="adv-radio">{{ $t('activity.male') }}</a-radio>
                <a-radio value="2" class="adv-radio">{{ $t('activity.female') }}</a-radio>
                <a-radio value="3" class="adv-radio">{{ $t('activity.mixed') }}</a-radio>
              </a-radio-group>
            </div>

            <!-- 选择年龄 -->
            <div class="adv-form-group">
              <label>{{ $t('activity.age') }}</label>
              <div class="adv-age-wrapper">
                <span class="age-value">{{ params.ages[0] }}</span>
                <a-slider v-model:value="params.ages" range :min="10" :max="100" :step="1" class="adv-slider" />
                <span class="age-value">{{ params.ages[1] }}</span>
              </div>
            </div>

            <!-- 购买金额 -->
            <div class="adv-form-group full-width">
              <label>{{ $t('activity.amount') }}</label>
              <a-radio-group v-model:value="params.amount" class="adv-radio-group adv-amount-group">
                <a-radio :value="100" class="adv-radio adv-amount-radio">$100</a-radio>
                <a-radio :value="500" class="adv-radio adv-amount-radio">$500</a-radio>
                <a-radio :value="1000" class="adv-radio adv-amount-radio">$1000</a-radio>
              </a-radio-group>
            </div>
          </div>

          <!-- 投放说明 -->
          <div class="adv-notice">
            <span class="notice-icon">ℹ️</span>
            {{ $t('_tl._tlfbqk_desc') }}
          </div>
        </div>
      </div>

      <!-- 底部 -->
      <div class="adv-buy-footer">
        <button class="adv-btn adv-btn-secondary" @click="onBack">{{ $t('activity.back') }}</button>
        <button class="adv-btn adv-btn-primary" @click="onSubmit">{{ $t('activity.join') }}</button>
      </div>
    </div>

    <!-- 密码输入框 -->
    <ToastPassword ref="pay" @sumbit="onPwdSubmit" :okText="$t('activity.join')"></ToastPassword>
  </div>
</template>

<script>
import ToastPassword from '@/components/adv/ToastPassword.vue'
// import videoAdv from '@/api/video_adv'

export default {
  name: 'AdvBuyVue',
  components: { ToastPassword },
  data() {
    return {
      current: {},
      countries: [],
      params: {
        country: 1,
        gender: '1',
        ages: [18, 45],
        amount: 100,
        pay_code: ''
      }
    }
  },
  created() {
    this.params.pay_code = this.$route.query.code
    this.getVideoAdv()
    this.getCountries()
  },
  methods: {
    onBack() {
      this.$router.push({ name: 'adv' })
    },

    getCountries() {
      this.$api.videoAdv
        .getCountry({})
        .then((res) => {
          if (res.code === 1) return
          if (res.data?.length > 0) {
            this.countries = res.data.map((item) => ({
              id: item.id,
              name: this.$t(item.key) || item.name,
              value: item.id
            }))
          }
        })
        .catch(() => {})
    },

    getVideoAdv() {
      this.$api.videoAdv
        .getVideoAdv({ code: this.$route.query.code })
        .then((res) => {
          if (res.code === 1) {
            this.$message.error(res.msg)
            return
          }
          if (!res.data?.id) {
            this.$message.error('activity is not exist')
            setTimeout(() => {
              this.$router.push({ name: 'adv' })
            }, 2000)
            return
          }
          this.current = res.data
          // 默认投流时间使用活动天数
          if (this.current.days) {
            // 保持显示
          }
        })
        .catch(() => {})
    },

    onSubmit() {
      const min = Number(this.current.price_min) || 0
      const max = Number(this.current.price_max) || Infinity
      const val = Number(this.params.amount)

      if (!this.params.amount || val < min) {
        this.$message.warning('min amount is $' + min)
        return
      }
      if (max < Infinity && val > max) {
        this.$message.warning('max amount is $' + max)
        return
      }
      this.$refs.pay.open()
    },

    onPwdSubmit(passwd) {
      this.$message.loading({ content: 'paying...', key: 'msg' })

      this.$api.videoAdv
        .payAdv({
          country: Number(this.params.country),
          gender: Number(this.params.gender),
          ages: this.params.ages,
          code: this.params.pay_code,
          amount: Number(this.params.amount),
          passwd: passwd
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            this.$refs.pay?.resetLoading()
            return
          }
          this.$refs.pay?.close()
          this.$message.success({ content: res.msg || 'pay success', key: 'msg' })
          this.$emit('success')
          setTimeout(() => {
            this.$router.push({ name: 'adv', query: { active: 'my' } })
          }, 1000)
        })
        .catch(() => {
          this.$refs.pay?.resetLoading()
        })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   活动购买 - 暗色主题
   主色: #e50914 (红色)
   辅色: #ffb300 (金色)
   ============================================================ */

.adv-buy-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  min-height: 100vh;
  background: #0b0d0f;
}

.adv-buy-card {
  background: #0f1419;
  border-radius: 16px;
  border: 1px solid #1a1f26;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* ============================================================
   头部
   ============================================================ */
.adv-buy-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #1a1f26;
  background: #0a0d0f;
}

.adv-buy-title {
  font-size: 19px;
  font-weight: 700;
  color: #e8edf2;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.adv-buy-title svg {
  flex-shrink: 0;
  stroke: #e50914;
}

.adv-close-btn {
  background: transparent;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5a6672;
  cursor: pointer;
  transition: all 0.3s ease;
}

.adv-close-btn:hover {
  background: rgba(229, 9, 20, 0.1);
  color: #e50914;
  transform: rotate(90deg);
}

/* ============================================================
   主体 - 左右布局
   ============================================================ */
.adv-buy-body {
  display: flex;
  gap: 24px;
  padding: 24px;
}

/* ============================================================
   封面图
   ============================================================ */
.adv-cover {
  flex: 0 0 280px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #0a0d0f;
  height: 360px;
  border: 1px solid #1a1f26;
}

.adv-cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.adv-cover:hover .adv-cover-img {
  transform: scale(1.03);
}

.adv-cover-badge {
  position: absolute;
  bottom: 14px;
  left: 14px;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 5px 16px;
  border-radius: 20px;
  color: #e8edf2;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.badge-code {
  color: #ffb300;
}

/* ============================================================
   信息区
   ============================================================ */
.adv-info {
  flex: 1;
  min-width: 0;
}

.adv-title {
  font-size: 22px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0 0 16px;
  line-height: 1.3;
}

/* ============================================================
   区块
   ============================================================ */
.adv-section {
  margin-bottom: 16px;
}

.adv-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.section-dot {
  width: 4px;
  height: 18px;
  background: #e50914;
  border-radius: 4px;
  flex-shrink: 0;
}

.adv-section-header h5 {
  font-size: 14px;
  font-weight: 600;
  color: #8a949f;
  margin: 0;
}

.adv-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #b0bcc8;
  background: #0a0d0f;
  padding: 14px 18px;
  border-radius: 10px;
  border: 1px solid #141a20;
  margin: 0;
}

/* ============================================================
   参与要求
   ============================================================ */
.adv-requirements {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.adv-requirement {
  background: #0a0d0f;
  border: 1px solid #141a20;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}

.adv-requirement:hover {
  border-color: #FF9800;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(229, 9, 20, 0.08);
}

.req-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}

.req-icon.dollar {
  background: rgba(38, 166, 154, 0.15);
  color: #26a69a;
}

.req-icon.crown {
  background: rgba(255, 179, 0, 0.15);
  color: #ffb300;
}

.req-icon.users {
  background: rgba(33, 150, 243, 0.15);
  color: #42a5f5;
}

.req-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.req-label {
  font-size: 11px;
  color: #5a6672;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.req-value {
  font-size: 15px;
  font-weight: 700;
  color: #e8edf2;
}

/* ============================================================
   表单网格
   ============================================================ */
.adv-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 18px;
  margin-top: 4px;
}

.adv-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.adv-form-group.full-width {
  grid-column: 1 / -1;
}

.adv-form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #8a949f;
  margin: 0;
}

/* ============================================================
   Ant Design 组件暗色适配
   ============================================================ */
/* Select */
.adv-form-group :deep(.ant-select-selector) {
  background: #0a0d0f !important;
  border-color: #1a1f26 !important;
  color: #e8edf2 !important;
  border-radius: 10px !important;
  height: 42px !important;
}

.adv-form-group :deep(.ant-select-selector:hover) {
  border-color: #FF9800 !important;
}

.adv-form-group :deep(.ant-select-focused .ant-select-selector) {
  border-color: #FF9800 !important;
  box-shadow: 0 0 0 3px rgba(229, 9, 20, 0.1) !important;
}

.adv-form-group :deep(.ant-select-arrow) {
  color: #5a6672 !important;
}

/* Radio */
.adv-radio-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.adv-radio {
  padding: 7px 18px;
  border-radius: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #1a1f26;
  font-weight: 500;
  font-size: 14px;
  color: #8a949f;
  background: transparent;
}

.adv-radio:hover {
  border-color: #FF9800;
  color: #e8edf2;
}

.adv-radio :deep(.ant-radio) {
  display: none;
}

.adv-radio :deep(.ant-radio + span) {
  padding: 0;
}

.adv-radio.ant-radio-wrapper-checked {
  background: rgb(255 152 0 / 12%);
  border-color: #ff9800;
  color: #ff9800;
}

/* 金额选择 - 更大间距 */
.adv-amount-group {
  gap: 12px;
}

.adv-amount-radio {
  padding: 10px 28px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
}

/* Slider */
.adv-age-wrapper {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 4px 0;
}

.age-value {
  font-size: 15px;
  font-weight: 700;
  color: #e8edf2;
  min-width: 30px;
  text-align: center;
}

.adv-slider {
  flex: 1;
}

.adv-slider :deep(.ant-slider-rail) {
  background: #1a1f26;
  height: 4px;
}

.adv-slider :deep(.ant-slider-track) {
  background: linear-gradient(90deg, #FF9800, #ffb300);
  height: 4px;
}

.adv-slider :deep(.ant-slider-handle) {
  border-color: #FF5722;
  background: #FF9800;
  width: 18px;
  height: 18px;
}

.adv-slider :deep(.ant-slider-handle:hover) {
  border-color: #ffb300;
}

.adv-slider :deep(.ant-slider-handle:focus) {
  border-color: #e50914;
  box-shadow: 0 0 0 3px rgba(229, 9, 20, 0.2);
}

/* ============================================================
   静态展示
   ============================================================ */
.adv-static-display {
  background: #0a0d0f;
  padding: 10px 16px;
  border-radius: 10px;
  border: 1px solid #1a1f26;
  font-weight: 600;
  color: #ffb300;
  font-size: 15px;
}

/* ============================================================
   投放说明
   ============================================================ */
.adv-notice {
  margin-top: 12px;
  padding: 12px 16px;
  background: rgba(255, 179, 0, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(255, 179, 0, 0.1);
  font-size: 13px;
  color: #8a949f;
  display: flex;
  align-items: center;
  gap: 8px;
}

.notice-icon {
  font-size: 16px;
  flex-shrink: 0;
}

/* ============================================================
   底部
   ============================================================ */
.adv-buy-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #1a1f26;
  background: #0a0d0f;
}

.adv-btn {
  padding: 10px 32px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 15px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.adv-btn-secondary {
  background: rgba(255, 255, 255, 0.06);
  color: #8a949f;
}

.adv-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #e8edf2;
}

.adv-btn-primary {
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(229, 9, 20, 0.25);
}

.adv-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(229, 9, 20, 0.35);
}

.adv-btn-primary:active {
  transform: translateY(0);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 820px) {
  .adv-buy-body {
    flex-direction: column;
    padding: 18px;
  }

  .adv-cover {
    flex: 0 0 auto;
    height: 200px;
    width: 100%;
  }

  .adv-title {
    font-size: 19px;
  }

  .adv-requirements {
    grid-template-columns: repeat(2, 1fr);
  }

  .adv-form-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .adv-form-group.full-width {
    grid-column: 1;
  }
}

@media (max-width: 640px) {
  .adv-buy-container {
    padding: 12px;
  }

  .adv-buy-header {
    padding: 14px 16px;
  }

  .adv-buy-title {
    font-size: 16px;
  }

  .adv-buy-body {
    padding: 14px;
  }

  .adv-cover {
    height: 160px;
  }

  .adv-title {
    font-size: 17px;
  }

  .adv-requirements {
    grid-template-columns: 1fr;
  }

  .adv-requirement {
    padding: 10px 12px;
  }

  .adv-buy-footer {
    flex-direction: column-reverse;
    padding: 14px 16px;
  }

  .adv-btn {
    justify-content: center;
    padding: 10px 20px;
  }

  .adv-amount-radio {
    padding: 8px 16px;
    font-size: 14px;
  }

  .adv-static-display {
    font-size: 14px;
    padding: 8px 14px;
  }
}

@media (max-width: 400px) {
  .adv-cover {
    height: 130px;
  }

  .adv-title {
    font-size: 15px;
  }

  .adv-desc {
    font-size: 13px;
    padding: 10px 14px;
  }

  .adv-radio {
    padding: 5px 12px;
    font-size: 13px;
  }

  .adv-amount-radio {
    padding: 6px 12px;
    font-size: 13px;
  }

  .adv-amount-group {
    gap: 8px;
  }
}
</style>
